import { createContext } from "react";

interface PaymentContextData {
  paymentData: { [key: string]: string | number | object } | undefined;
  handlePaymentData:
    | ((data: { [key: string]: string | number | object }) => void)
    | undefined;
}

export const PaymentContext = createContext<PaymentContextData>({
  paymentData: {},
  handlePaymentData: undefined,
});
